export default "__VITE_ASSET__$_QempiZ__"